import React from 'react'
import { FaUsers, FaHandshake, FaStar } from "react-icons/fa";
const AboutWhyChooseUs = () => {
  return (
    <section className="why-choose-us py-5 bg-light">
    <div className="container text-center">
      <h2 className="fw-bold mb-5">Why Choose Us</h2>
      <div className="row">
        <div className="col-md-4 mb-4">
          <FaUsers size={50} className="main-color mb-3" />
          <h5 className="fw-bold">Expert Team</h5>
          <p className="text-muted">We have a dedicated team that cares about your needs.</p>
        </div>
        <div className="col-md-4 mb-4">
          <FaHandshake size={50} className="main-color mb-3" />
          <h5 className="fw-bold">Trusted Service</h5>
          <p className="text-muted">Thousands of customers trust us every day.</p>
        </div>
        <div className="col-md-4 mb-4">
          <FaStar size={50} className="main-color mb-3" />
          <h5 className="fw-bold">Top Quality</h5>
          <p className="text-muted">We provide only high-quality and verified products.</p>
        </div>
      </div>
    </div>
  </section>
  )
}

export default AboutWhyChooseUs